export const getCurrentUrlWithCompanyAppended = (host?: string, companyId?: string) => {
  const origin = window.whitelabelConfiguration.host || host || window.location.origin;
  const path = window.location.pathname;
  const params = (window.location.search ? `${window.location.search}&` : '?') + `company_id=${companyId || window.companyId}`;

  return `${origin}${path}${params}`;
};
